// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.X_tnEZTXr3 {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.X_tnEZTXr3 h4 {
  line-height: 3em;
}
.X_tnEZTXr3 .MaOeY2uXMm {
  float: left;
  width: 100%;
}
.X_tnEZTXr3 .zr5KzLzb91 {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.X_tnEZTXr3 .zr5KzLzb91:hover {
  cursor: pointer;
}
.X_tnEZTXr3 .zr5KzLzb91:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.dnaeMFHhOD .SQQyez2oSl:focus {
  outline: none;
}
.dnaeMFHhOD .SQQyez2oSl.LRR1BKxzHz.C2JvYaCSWz {
  background: #375A88;
}
.dnaeMFHhOD .SQQyez2oSl.LRR1BKxzHz.C2JvYaCSWz span {
  color: #fff;
}
.dnaeMFHhOD .C2JvYaCSWz {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.dnaeMFHhOD .C2JvYaCSWz:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.dnaeMFHhOD input {
  height: 38px;
  min-width: 220px;
}
.zr5KzLzb91.ctp46UUJU4 {
  background: #410102;
}
.zr5KzLzb91.EJ_gphi94G {
  background: #911318;
}
.zr5KzLzb91.lvc1RXazCA {
  background: #D8293B;
}
.zr5KzLzb91.BaJp48nNwc {
  background: #F2373C;
}
.zr5KzLzb91.L1rFiEjq9F {
  background: #FC4448;
}
.zr5KzLzb91.fPMYUhtNOt {
  background: #ED535E;
}
.zr5KzLzb91.sbG47PuI2S {
  background: #E34926;
}
.zr5KzLzb91.IOr6zHcU6_ {
  background: #FC562B;
}
.zr5KzLzb91.TTAPO5rCs0 {
  background: #FC6722;
}
.zr5KzLzb91.dICtI_CU__ {
  background: #FD7F24;
}
.zr5KzLzb91.q11_trFbDc {
  background: #FD8D26;
}
.zr5KzLzb91.kurY93z_kL {
  background: #EC9C3E;
}
.zr5KzLzb91._LzNw0SCFG {
  background: #0e673a;
}
.zr5KzLzb91.alcVnWy5V9 {
  background: #208740;
}
.zr5KzLzb91.Y5ZqRuGmGs {
  background: #239718;
}
.zr5KzLzb91.CEJdSsj2rk {
  background: #55A84D;
}
.zr5KzLzb91.ftaPM6A069 {
  background: #4BBE5A;
}
.zr5KzLzb91.M9CVZh9mrY {
  background: #0CCA6A;
}
.zr5KzLzb91.eSEo1sfvuR {
  background: #0A3C64;
}
.zr5KzLzb91.WLu5OvPAVX {
  background: #0d487a;
}
.zr5KzLzb91.tzMBNfbziu {
  background: #10538d;
}
.zr5KzLzb91.RTIA8I2fqJ {
  background: #115A99;
}
.zr5KzLzb91.acfLOdZDb9 {
  background: #3387E2;
}
.zr5KzLzb91.DWKscR01xj {
  background: #1BA9CF;
}
.zr5KzLzb91.znGtITm_lM {
  background: #d27c02;
}
.zr5KzLzb91.g00xY1Irue {
  background: #fb9402;
}
.zr5KzLzb91.u6ZyMhwaWV {
  background: #FD9B30;
}
.zr5KzLzb91.ih8RoLtsQK {
  background: #FDBE2D;
}
.zr5KzLzb91.lqyK2oqYFZ {
  background: #FED831;
}
.zr5KzLzb91.gk0U32Z8TC {
  background: #FFFD38;
}
.zr5KzLzb91.Yz83wRgB4M {
  background: #2D215C;
}
.zr5KzLzb91.e2GoDzkGTc {
  background: #483C83;
}
.zr5KzLzb91.mO2ydAQC13 {
  background: #58518d;
}
.zr5KzLzb91.Fz3AZEE4Dk {
  background: #7068A9;
}
.zr5KzLzb91.WSwlq2nJH9 {
  background: #7f78b2;
}
.zr5KzLzb91.IRXvFYn2vO {
  background: #8f88bc;
}
.zr5KzLzb91.OZpdQu1H1X {
  background: #000;
}
.zr5KzLzb91.TGqslZstIa {
  background: #282626;
}
.zr5KzLzb91.dIxKBiK0t8 {
  background: #242222;
}
.zr5KzLzb91.BggUarVcAH {
  background: #353838;
}
.zr5KzLzb91.IrBj3x5Hv8 {
  background: #666;
}
.zr5KzLzb91.xsv2NKkrhS {
  background: #999;
}
.TAXmH2zNsU {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.TAXmH2zNsU .xwt5zXAPEx {
  display: none;
}
.rRQTzlgdER {
  height: 100%;
}
.rRQTzlgdER .RInuMTjRA5 {
  position: relative;
  display: flex;
  border-bottom: 1px solid #444444;
  margin-bottom: 20px;
  padding-bottom: 20px;
}
.rRQTzlgdER .jM9Clo0wca {
  width: 120px;
  height: 80px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rRQTzlgdER .jM9Clo0wca:hover .s253U9hBy1 {
  opacity: 1;
}
.rRQTzlgdER .s253U9hBy1.s253U9hBy1 {
  transition: 0.15s;
  opacity: 0;
  font-size: 1rem;
  height: auto;
  background: rgba(0, 0, 0, 0.5);
  padding: 6px;
  color: #FFF;
}
.rRQTzlgdER .s253U9hBy1.s253U9hBy1:hover {
  background: rgba(0, 0, 0, 0.5);
  color: #FFF;
}
.rRQTzlgdER .nnIGoOpGJo {
  flex: 1;
  width: 100%;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
}
.rRQTzlgdER .jg2Nw7Pzd_ {
  color: #FFF;
  font-size: 1.2rem;
  font-weight: 400;
  text-transform: none;
  margin-bottom: 0.2rem;
}
.rRQTzlgdER .h_hMw2X0aM {
  display: flex;
  margin-bottom: 0.4rem;
}
.rRQTzlgdER .uryJz7cDUg,
.rRQTzlgdER .ApgvZOK5Pm,
.rRQTzlgdER .KoAE9wAZxv {
  color: #FFF;
  font-size: 0.8rem;
  white-space: nowrap;
}
.rRQTzlgdER .Qu29xHsYqe.Qu29xHsYqe {
  color: #fff;
  border-radius: 2px;
  border-color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  font-weight: 400;
  text-transform: uppercase;
  transition: 0.15s;
}
.rRQTzlgdER .Qu29xHsYqe.Qu29xHsYqe:hover {
  color: #000;
  background-color: #fff;
}
.rRQTzlgdER .Qu29xHsYqe.Qu29xHsYqe .GH_Mf6LVck .l9Nu6tYJv7 {
  font-size: 1.1rem;
}
.RqErYGikp_.RqErYGikp_ {
  background: #375a87;
  justify-content: flex-start;
  min-height: 84px;
}
.RqErYGikp_.RqErYGikp_ .l9Nu6tYJv7 {
  font-size: 34px;
}
.RqErYGikp_.RqErYGikp_ .h_hMw2X0aM {
  margin-bottom: 0;
  padding: 0 15px;
}
.RqErYGikp_.RqErYGikp_ > div:nth-child(2) {
  flex: none;
}
.RqErYGikp_.RqErYGikp_ .cYggut60lg.cYggut60lg {
  overflow: hidden;
  flex-grow: 0;
  flex-basis: auto;
}
.RqErYGikp_.RqErYGikp_ .cYggut60lg.cYggut60lg > div {
  overflow: hidden;
}
.RqErYGikp_.RqErYGikp_ .cYggut60lg.cYggut60lg .rbsokfOWyd {
  font-size: 1.2rem;
}
.tuqvzAQjWp.tuqvzAQjWp {
  height: auto;
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 4px 3px 3px 4px;
}
.tuqvzAQjWp.tuqvzAQjWp:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
.tuqvzAQjWp.tuqvzAQjWp .l9Nu6tYJv7 {
  font-size: 1rem;
  width: 13px;
}
.Ip3YI87_a0 {
  padding: 0 20px 20px;
  height: 50vh;
  width: 860px;
  overflow: hidden auto;
}
.o8OWRFhMMX .lZSAVvZk3l {
  max-width: 860px;
}
.o8OWRFhMMX .WFeqK7AUvU {
  background-color: rgba(255, 255, 255, 0.75);
}
.AVi81h5JH1.AVi81h5JH1 {
  margin-bottom: 0;
  border-radius: 10px;
  padding: 2px;
  font-size: 11px;
  text-transform: uppercase;
  height: 18px;
  background-color: #f8cb4d;
}
.AVi81h5JH1.ydG2JNY4Ji {
  background: #EEEEEE;
  border-color: #EEEEEE;
  color: #0B0101;
  text-transform: uppercase;
}
.AVi81h5JH1.LyJnRrtDyy {
  background-color: #F8CB4D;
  opacity: 1;
  margin-left: 4px;
}
@media screen and (max-width: 787px) {
  .Qu29xHsYqe {
    position: static;
  }
  .o8OWRFhMMX {
    padding: 12px;
  }
  .o8OWRFhMMX .lZSAVvZk3l {
    height: auto;
  }
  .o8OWRFhMMX .lZSAVvZk3l .qYKrvBbYJX {
    overflow: hidden;
    min-width: auto;
  }
  .o8OWRFhMMX .tuqvzAQjWp {
    width: auto;
  }
  .o8OWRFhMMX .tuqvzAQjWp span {
    margin-left: 0;
    margin-right: 0;
  }
  .Ip3YI87_a0 {
    width: auto;
  }
  .RqErYGikp_ {
    display: grid;
  }
  .RqErYGikp_ .h_hMw2X0aM {
    margin: 0 40px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `X_tnEZTXr3`,
	"color-row": `MaOeY2uXMm`,
	"color-tile": `zr5KzLzb91`,
	"picker-component": `dnaeMFHhOD`,
	"picker-element": `SQQyez2oSl`,
	"active": `LRR1BKxzHz`,
	"btn": `C2JvYaCSWz`,
	"red-1": `ctp46UUJU4`,
	"red-2": `EJ_gphi94G`,
	"red-3": `lvc1RXazCA`,
	"red-4": `BaJp48nNwc`,
	"red-5": `L1rFiEjq9F`,
	"red-6": `fPMYUhtNOt`,
	"orange-1": `sbG47PuI2S`,
	"orange-2": `IOr6zHcU6_`,
	"orange-3": `TTAPO5rCs0`,
	"orange-4": `dICtI_CU__`,
	"orange-5": `q11_trFbDc`,
	"orange-6": `kurY93z_kL`,
	"green-1": `_LzNw0SCFG`,
	"green-2": `alcVnWy5V9`,
	"green-3": `Y5ZqRuGmGs`,
	"green-4": `CEJdSsj2rk`,
	"green-5": `ftaPM6A069`,
	"green-6": `M9CVZh9mrY`,
	"blue-1": `eSEo1sfvuR`,
	"blue-2": `WLu5OvPAVX`,
	"blue-3": `tzMBNfbziu`,
	"blue-4": `RTIA8I2fqJ`,
	"blue-5": `acfLOdZDb9`,
	"blue-6": `DWKscR01xj`,
	"yellow-1": `znGtITm_lM`,
	"yellow-2": `g00xY1Irue`,
	"yellow-3": `u6ZyMhwaWV`,
	"yellow-4": `ih8RoLtsQK`,
	"yellow-5": `lqyK2oqYFZ`,
	"yellow-6": `gk0U32Z8TC`,
	"purple-1": `Yz83wRgB4M`,
	"purple-2": `e2GoDzkGTc`,
	"purple-3": `mO2ydAQC13`,
	"purple-4": `Fz3AZEE4Dk`,
	"purple-5": `WSwlq2nJH9`,
	"purple-6": `IRXvFYn2vO`,
	"black-1": `OZpdQu1H1X`,
	"black-2": `TGqslZstIa`,
	"black-3": `dIxKBiK0t8`,
	"black-4": `BggUarVcAH`,
	"black-5": `IrBj3x5Hv8`,
	"black-6": `xsv2NKkrhS`,
	"picker-theme": `TAXmH2zNsU`,
	"arrow-regular": `xwt5zXAPEx`,
	"version-tab": `rRQTzlgdER`,
	"version-tab__version": `RInuMTjRA5`,
	"version-tab__asset-thumbnail": `jM9Clo0wca`,
	"version-tab__download-button": `s253U9hBy1`,
	"version-tab__asset-detail": `nnIGoOpGJo`,
	"version-tab__asset-title": `jg2Nw7Pzd_`,
	"version-tab__asset-labels": `h_hMw2X0aM`,
	"version-tab__asset-uploaded-date": `uryJz7cDUg`,
	"version-tab__asset-uploader": `ApgvZOK5Pm`,
	"version-tab__asset-file-size": `KoAE9wAZxv`,
	"version-tab__asset-show-comments": `Qu29xHsYqe`,
	"version-tab__asset-show-comments-icon": `GH_Mf6LVck`,
	"pulse-icon": `l9Nu6tYJv7`,
	"version-comments__modal-header": `RqErYGikp_`,
	"version-comments__title-container": `cYggut60lg`,
	"version-comments__title-primary": `rbsokfOWyd`,
	"version-comments__close-button": `tuqvzAQjWp`,
	"version-comments__modal-content": `Ip3YI87_a0`,
	"version-comments__dialog-root": `o8OWRFhMMX`,
	"version-comments__dialog-paper": `lZSAVvZk3l`,
	"version-comments__dialog-backdrop-root": `WFeqK7AUvU`,
	"version-tab__asset-label": `AVi81h5JH1`,
	"version-tab__asset-label--version": `ydG2JNY4Ji`,
	"version-tab__asset-label--status": `LyJnRrtDyy`,
	"MuiDialogContent-root": `qYKrvBbYJX`
};
export default ___CSS_LOADER_EXPORT___;
